import {
  AutoComplete,
  AutoCompleteCountry,
  FormInput,
  ISelectCountry,
  ISelectType,
  useFormContext,
} from "@4uhub/lib4uhub";
import { Grid, IconButton } from "@mui/material";
import { useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import DeleteIcon from "@mui/icons-material/Delete";
import { listMainGenerics } from "../../../../../services/generic.service";

const translationPath = "page.4uDonation.donors.form.";

interface DonorContactRowProps {
  index: number;
  remove: (index: number) => void;
  countries: ISelectCountry[];
  generics: ISelectType[];
}

export const DonorContactRow = ({
  index,
  remove,
  countries,
  generics,
}: DonorContactRowProps) => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const selectedCountry = useWatch({
    control,
    name: `contactsObject.${index}.ddiCode`,
  });

  const phoneMask = selectedCountry?.phoneMask;

  return (
    <Grid container spacing={2} sx={{ mb: 2, alignItems: "center" }}>
      <Grid item xs={12} sm={3}>
        <AutoComplete
          name={`contactsObject.${index}.donorContactType`}
          params={{ Identifier: "DonorContactType" }}
          label={t(translationPath + "contact_type") || "Tipo de Contato"}
          getOptionLabel={(option) => option.name}
          options={generics}
          fullWidth
          size="small"
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <AutoCompleteCountry
          name={`contactsObject.${index}.ddiCode`}
          label={t(translationPath + "ddi") || "País (DDI)"}
          size="small"
          getOptionLabel={(option) => `${option.code} (+${option.ddiCode})`}
          options={countries}
        />
      </Grid>
      <Grid item xs={12} sm={5}>
        <FormInput
          name={`contactsObject.${index}.value`}
          label={t(translationPath + "contact_number") || "Valor"}
          mask={phoneMask}
          fullWidth
          size="small"
        />
      </Grid>
      <Grid item xs={12} sm={1} sx={{ textAlign: "center" }}>
        <IconButton onClick={() => remove(index)} color="error">
          <DeleteIcon />
        </IconButton>
      </Grid>
    </Grid>
  );
};
